















































































# import settings from '@/settings'
import salaries_graph from '@/components/collaborators_charts/salaries_graph'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'users_salaries'

    components: { salaries_graph }

    props: {
        uid: {
            type: String
        }
    }

    data: ()->
        has_mutation_right: false
        has_payslips_right: false
        has_deletion_right: false
        graph_datas: []
        graph_categories: []
        errors: {}
        loading: true
        alert: false
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        active_names: [1]
        false: false
        min: 0
        readonly: false
        salary: {
            uid: ''
            user_uid: @uid
            base: 0
            bonus: 0
            period: ''
        }
        salaries: []

    computed:
        data_filtered: ()->
            self = @
            data = @salaries.filter (x) ->
                !self.search || x.base.toString().toLowerCase().includes(self.search.toLowerCase()) \
                || x.bonus.toString().toLowerCase().includes(self.search.toLowerCase()) \
                || self.date_formatter(x.period).toLowerCase().includes(self.search.toLowerCase()) \
                || x.evolution.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        save_text: ()->
            text = "Ajouter"
            if @salary.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter une rémunération"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        has_access_right: t.has_access_right

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @salaries.sort (a,b)->
                modifier = 1
                if order == 'descending'
                    modifier = -1
                if prop == 'evolution'
                    a = parseFloat(a[prop].slice(1,-2))
                    b = parseFloat(b[prop].slice(1,-2))
                    # console.log "SPLICE ", a, b
                    if a < b
                        return -1 * modifier
                    if a > b
                        return 1 * modifier
                else
                    if a[prop] < b[prop]
                        return -1 * modifier
                    if a[prop] > b[prop]
                        return 1 * modifier
                return 0

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        date_formatter: (date)->
            new_date = ""
            if date?
                date_array = date.split('-')
                new_date = date_array[0]+'/'+date_array[1]
            return new_date

        reset_salary: ()->
            @salary = {
                uid: ''
                user_uid: @uid
                base: 0
                bonus: 0
                period: ''
            }
            return

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_salary()
            return

        go_to_payslips: ()->
            if @$route.name == 'company_users_salaries'
                @$router.push({name:"company_users_pay_slips", params:{uid:@uid}})
            else
                @$router.push({name:"users_pay_slips", params:{uid:@uid}})
            return

        edit_salary: (index)->
            @salary = t.deep_copy(@salaries[index])
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0
            @errors = {}
            return

        define_accesses: ()->
            if @$route.name == 'company_users_salaries'
                @has_mutation_right = @has_access_right('user_salaries_edit')
                @has_deletion_right = @has_access_right('user_salaries_delete')
                @has_payslips_right = @has_access_right('pay_slips_edit')
            else
                @has_mutation_right = @has_access_right('user_salaries_self_edit')
                @has_deletion_right = @has_access_right('user_salaries_self_delete')
                @has_payslips_right = @has_access_right('pay_slips_self_edit')
            return

        delete_salary: (salary_uid)->
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette rémunération ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_object', ['user_salary', salary_uid])
                    .then (resp)->
                        if resp.body.data.user_salary_deletion.ok
                            n.success()
                            self.get_salaries()
                        else
                            n.gql_error("users_salaries: delete_salary: then", resp.body.data.user_salary_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_salaries: delete_salary()")
                .catch (cancel)->
                    return

        save: ()->
            self = @
            @salary.user_uid = @uid
            m.run('save_salary', [@salary])
            .then (resp)->
                if resp.body.data.user_salary_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.user_salary_form_mutation.errors.length > 0
                    self.errors = resp.body.data.user_salary_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_salary()
                    self.active_names = [1]
                    self.get_salaries()
            .catch (resp)->
                n.catch_error(resp, "users_salaries: save()")

        get_salaries: ()->
            self = @
            @loading = true
            q.run('get_salary_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_salaries: get_salaries: then", e.message)
                else
                    # console.log "GET SALARIES : ", resp.body.data.salary_set
                    self.salaries = resp.body.data.salary_set
                    self.graph_categories = self.salaries
                        .slice()
                        .reverse()
                        .filter (x)->
                            return x.base > 0
                        .map (x)->
                            return self.date_formatter(x.period)
                    self.graph_datas = self.salaries
                        .slice()
                        .reverse()
                        .filter (x)->
                            return x.base > 0
                        .map (x)->
                            return x.base
                    self.loading = false
                    if self.salaries.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "users_salaries: get_salaries()")
            
    beforeMount: ()->
        # console.log "SALARIES MOUNT"
        @define_accesses()
        if @uid != '0'
            @get_salaries()
}
